// extracted by mini-css-extract-plugin
export default {"link":"PrivacyPolicy_link__PUJIO","boldText":"PrivacyPolicy_boldText__DNRKG","listItem":"PrivacyPolicy_listItem__7-e0t","list":"PrivacyPolicy_list__aU4ed"};